import React from 'react'

import {
  AppointmentField,
  FieldSpec,
  LinkedField,
  NumberField,
  PaginatedTable,
  ValueField,
  StatusField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  trackingNumber: { id: 'trackingNumber', label: 'Tracking Number', ordering: 'tracking_number', renderer: LinkedField(ValueField) },
  billOfLadingNumber: { id: 'billOfLadingNumber', label: 'BoL', ordering: 'bill_of_lading_number', renderer: ValueField },
  trailerNumber: { id: 'trailerNumber', label: 'Trailer Number', ordering: 'trailer_number', renderer: ValueField },
  client: { id: 'client.name', label: 'Client', ordering: 'account__name', renderer: ValueField },
  facility: { id: 'facility.name', label: 'Facility', ordering: 'facility__name', renderer: ValueField },
  carrier: { id: 'carrier.name', label: 'Carrier', ordering: 'carrier__name', renderer: ValueField },
  status: { id: 'status', label: 'Status', renderer: StatusField },
  appointment: {
    id: 'appointment',
    label: 'Appointment',
    renderer: AppointmentField,
  },
  numOrders: {
    id: 'numOrders',
    label: 'Number of Orders',
    renderer: NumberField,
  },
}

export const TruckloadListTable = (props: ListTableProps) => {
  const { paginator, fields, exportConfig, title="Truckloads" } = props

  return (
    <>
      <PaginatedTable
        title={title}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
